import { useQuery } from '@tanstack/react-query';
import { IImpersonationContext, ImpersonationBroker, IPagedCollection, IUser } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'user/autocomplete';

export function useUserAutocompleteQuery({
	fragment,
	pageSize = 25,
	enforcePageSize = true,
	enabled,
	includeDeactivated,
	domain,
	impersonationContext,
}: {
	fragment: string;
	pageSize?: number;
	enforcePageSize?: boolean;
	enabled?: boolean;
	includeDeactivated?: boolean;
	domain?: string;
	impersonationContext?: IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_QUERY_KEY, fragment, includeDeactivated, pageSize, enforcePageSize, domain, impersonationContext],
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<IPagedCollection<IUser>>(
				ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `user/autocomplete`,
					queryParams: {
						enforcePageSize,
						fragment,
						pageSize,
						includeDeactivated,
						domain,
					},
				}),
				'GET'
			);
		},
		enabled,
	});
}
